import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { HttpService } from './http.service';
import { HttpParams } from '@angular/common/http';
import { UserService } from './user.service';

@Injectable()
export class CheckoutService {

    private url: string = environment.base_url;

    constructor(
        private httpService: HttpService,
        private userService: UserService
    ) {
    }

    checkout(customerReference: any, specialInstructions: any) {
        let httpParams: HttpParams = new HttpParams();
        httpParams = httpParams.set('company', this.userService.getCompany()['id']);
        const payload = {
            customer_reference : customerReference,
            special_instructions : specialInstructions
        };
        return this.httpService.post(this.url + '/b2b/checkout', payload, httpParams).map(resp => resp);
    }

    orderHistory(httpParams: HttpParams = new HttpParams()) {
        httpParams = httpParams.set('company', this.userService.getCompany()['id']);
        return this.httpService.get(this.url + '/b2b/order_history/search', httpParams).map(resp => resp);
    }

    orderSummary(requisitionsIds: any) {
        let httpParams: HttpParams = new HttpParams();
        httpParams = httpParams.set('company', this.userService.getCompany()['id']);
        return this.httpService.get(this.url + '/b2b/checkout/order/' + requisitionsIds, httpParams).map(resp => resp);
    }

    placeOrder(requisitionsIds: any, customerReference: any, specialInstructions: any) {
        let httpParams: HttpParams = new HttpParams();
        httpParams = httpParams.set('company', this.userService.getCompany()['id']);
        const payload = {
            customer_reference : customerReference,
            special_instructions : specialInstructions
        };
        return this.httpService.post(this.url + '/b2b/checkout/order/' + requisitionsIds, payload, httpParams).map(resp => resp);
    }

}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/shared/services/checkout.service.ts